export const CURRENCY = ['USD', 'INR', 'GBP', 'EUR', 'AUD', 'IDR', 'CAD'];
export const LOCALE_MAPPER = {
    usd: 'en',
    us: 'en',
    'en-us': 'en',
    ind: 'ind',
    inr: 'ind',
    gbp: 'en-gb',
    eur: 'en-eur',
    aud: 'en-au',
    idr: 'id-ID',
    xof: 'xof',
    cfa: 'cfa',
    cad: 'en-ca'
};
export const CURRENCY_LOCALE_MAPPER = {
    USD: 'en-US',
    INR: 'en-IN',
    IDR: 'id-ID',
    CAD: 'en-ca',
    AUD: 'en-au'
};
